export const certificateFlows = Object.freeze(
  /** @type {const} */ ({
    OUTBOUND: 'OUTBOUND',
  })
);
